import cookies from './cookies';
export default cookies;
